export default __webpack_public_path__ + "static/media/ic_soft-skills.8a7891c6.svg";